const inputLabelFormParamEquip = {
  label: 'Type'
};

export default inputLabelFormParamEquip;
